import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "animate.css/animate.css";
import "./styles/index.scss";

import use from "./core/use";

const app = createApp(App);

app.use(store);
app.use(router);
app.use(use);

app.mount("#app");
